module.exports = __webpack_public_path__ + "img/Vision.ec121c3e.svg";